/**
 * External dependencies
 */
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Box, Text } from "@towersystems/towersystems-design-system";
import classnames from "classnames";

/**
 * Internal dependencies
 */
import {
  requestInProgressOperation,
  cancelOperation,
} from "state/import-operation/actions";
import { getInProgressOperation } from "state/import-operation/selectors";
import Button from "components/button";

/**
 * Style dependencies
 */
import "./styles.scss";

const OperationProgress = ({ operation, ...props }) => {
  useEffect(() => {
    let _intervalID = setInterval(async () => {
      await checkOperation();
    }, 10000);
    return () => {
      clearTimeout(_intervalID);
    };
  }, []);

  const checkOperation = async () => {
    await props.requestInProgressOperation();
  };

  const cancelOperation = async () => {
    await props.cancelOperation(operation.id);
  };

  const classes = classnames("operation-progress");

  if (!operation) {
    return null;
  }

  const canCancel =
    operation.status === "pending" || operation.status === "processing";

  return (
    <Box
      className={classes}
      alignItems="center"
      justifyContent="center"
      display="flex"
      flexDirection="column"
    >
      <Text>Status: {operation.status}</Text>
      <Text>Imported: {operation.object_count}</Text>
      <Button disabled={!canCancel} onClick={cancelOperation}>
        cancel
      </Button>
    </Box>
  );
};

export default connect(
  (state) => ({
    operation: getInProgressOperation(state),
  }),
  { requestInProgressOperation, cancelOperation }
)(OperationProgress);
